const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      fillRule="evenodd"
      strokeWidth="1"
      d="M0 5.66c0-.297.119-.582.33-.792.21-.21.497-.327.795-.327h21.75c.298 0 .585.117.795.327a1.116 1.116 0 0 1 0 1.583c-.21.21-.497.327-.795.327H1.125c-.298 0-.585-.118-.795-.327A1.12 1.12 0 0 1 0 5.659M0 12c0-.297.119-.581.33-.791.21-.21.497-.328.795-.328h21.75c.298 0 .585.118.795.328a1.116 1.116 0 0 1 0 1.582c-.21.21-.497.328-.795.328H1.125c-.298 0-.585-.118-.795-.328A1.12 1.12 0 0 1 0 12m1.125 5.222c-.298 0-.585.117-.795.327a1.116 1.116 0 0 0 0 1.583c.21.21.497.327.795.327h21.75c.298 0 .585-.117.795-.327a1.116 1.116 0 0 0 0-1.583 1.13 1.13 0 0 0-.795-.327z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default SvgIcon;
